// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"45b5f8ec","977":"2cb22ec4"}[chunkId] + ".chunk.js";
};